import React, { useState } from "react";
import TopNavBar from "../../components/reusables/topNavBar";
import NotificationsService from "../../rest/notificationService";

export default function EmailMarketingPage() {
    const [from, setFrom] = useState("");
    const [password, setPassword] = useState("");
    const [to, setTo] = useState("");
    const [subject, setSubject] = useState("");
    const [provider, setProvider] = useState("google");
    const [html, setHtml] = useState("<h1>Bem-vindo ao Foodz!</h1>");
    const [css, setCss] = useState("h1 { color: #CA2121; }");
    const [status, setStatus] = useState("");

    const handleSend = async () => {
        try {
            setStatus("Enviando...");

            const response = await NotificationsService.sendEmailMkt({
                provider,
                from,
                password,
                to: to.split(",").map((email) => email.trim()),
                subject,
                html,
                css,
            });

            setStatus("Email enviado com sucesso!"); 
        } catch (err) {
            setStatus("Erro ao enviar: " + err.message);
        }
    };


    return (
        <div className='w-full h-full md:ml-[100px]'>
            <TopNavBar title={"Envio de Email"} subtitle={"Envio de email marketing e afins."} />
            <div className='mx-2 sm:mx-10 my-6 font-poppins text-custom_lighter_gray_font'>
                <div className="p-8 w-full mx-auto space-y-6">
                    <h1 className="text-3xl font-bold text-[#CA2121]">Envio de Email Marketing</h1>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block font-semibold">Remetente (Email)</label>
                            <input value={from} onChange={(e) => setFrom(e.target.value)} className="border p-2 w-full rounded" />
                        </div>
                        <div>
                            <label className="block font-semibold">Senha</label>
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="border p-2 w-full rounded" />
                        </div>
                    </div>

                    <div>
                        <label className="block font-semibold">Provedor</label>
                        <select value={provider} onChange={(e) => setProvider(e.target.value)} className="border p-2 w-full rounded">
                            <option value="google">Google</option>
                            <option value="microsoft">Microsoft</option>
                            <option value="apple">Apple</option>
                        </select>
                    </div>

                    <div>
                        <label className="block font-semibold">Destinatários (separar por vírgula)</label>
                        <input value={to} onChange={(e) => setTo(e.target.value)} className="border p-2 w-full rounded" />
                    </div>

                    <div>
                        <label className="block font-semibold">Assunto</label>
                        <input value={subject} onChange={(e) => setSubject(e.target.value)} className="border p-2 w-full rounded" />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block font-semibold">HTML do Email</label>
                            <textarea
                                rows={10}
                                value={html}
                                onChange={(e) => setHtml(e.target.value)}
                                className="border p-2 w-full rounded font-mono text-sm"
                            />
                        </div>

                        <div>
                            <label className="block font-semibold">CSS</label>
                            <textarea
                                rows={10}
                                value={css}
                                onChange={(e) => setCss(e.target.value)}
                                className="border p-2 w-full rounded font-mono text-sm"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block font-semibold mb-2">Pré-visualização:</label>
                        <div className="w-full border rounded-lg h-96 bg-white resize-y overflow-auto">
                            <iframe
                                title="preview"
                                className="w-full h-full"
                                srcDoc={`<html><head><style>${css}</style></head><body>${html}</body></html>`}
                            />
                        </div>
                    </div>

                    <button
                        onClick={handleSend}
                        className="bg-[#33B246] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#2B5BA3] transition"
                    >
                        Enviar E-mails
                    </button>

                    {status && <p className="mt-4 font-medium">{status}</p>}
                </div>
            </div>
        </div>


    );
}